import { useTraversal } from '@guillotinaweb/react-gmi'
import { useState } from 'react'
import { message } from 'antd'
import { getGoogleMapsDataFromURL } from './partials/location'

export default function useSaveCellar() {
  const ctx = useTraversal()
  const [saving, setSaving] = useState(false)
  const cellar = ctx.state.context
  const folder = `bodegas/${cellar.internal_id}`

  async function save(fields = {}, showMsg = false) {
    setSaving(true)
    try {
      const r = await ctx.client.patch(ctx.path, fields)
      const oldMapURL = cellar.googlemap_url
      const mapUrlUpdated = fields.googlemap_url !== oldMapURL

      if (oldMapURL && fields.googlemap_url === '') {
        await deleteMapImage()
      } else if (mapUrlUpdated && fields.googlemap_url) {
        await uploadMapImage(fields)
      }

      if (r.status >= 400) throw new Error((await r.json()).message)
      setSaving(false)
      if (!showMsg) message.success(`Saved successfully.`)
      ctx.refresh({ transparent: true })
    } catch (e) {
      setSaving(false)
      message.error(`Error saving. ${e.message}`)
    }
  }

  async function uploadMapImage(fields) {
    message.info('Uploading location map image...')

    const { img } = getGoogleMapsDataFromURL(fields.googlemap_url)
    const imgFile = await getFileFromUrl(img, 'googlemap_img.png')

    let res = await ctx.client.upload(
      ctx.path,
      imgFile,
      folder,
      'googlemap_img'
    )

    if (res.status !== 200)
      return message.error('Error uploading location map image')
  }

  async function deleteMapImage() {
    message.info('Deleting location map image...')
    let res = await ctx.client.deleteFile(ctx.path, 'googlemap_img')
    if (res.status !== 200)
      return message.error('Error deleting location map image')
  }

  return [saving, save]
}

async function getFileFromUrl(url, filename, contentType = 'image/png') {
  const response = await fetch(url)
  const blob = await response.blob()
  return {
    contentType,
    data: await blob.arrayBuffer(),
    filename,
  }
}
